var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about_zz"},_vm._l((_vm.items),function(item,index){return _c('content-card',{key:index,attrs:{"items":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }